import React, { useState, useEffect } from 'react';
import Logo from '@BUP/assets/Images/bup_logo.png';
import { useAuth } from '@BUP/hooks';
import { useHistory } from 'react-router-dom';
import { Row, Col, Card, Form, Input, Button } from 'antd';
import styles from './password-reset-spanish.module.css';

const PasswordResetSpanishPage = () => {
  const history = useHistory();
  const [form] = Form.useForm();
  const [, forceUpdate] = useState();
  const [error, setError] = useState(null);
  const { emailPasswordReset } = useAuth();

  const onSubmit = async (values) => {
    try {
      const { email } = values;
      console.log('PasswordResetPage submit', email);
      await emailPasswordReset(email);
      setError(null);
      history.push('/login');
    } catch (e) {
      console.log('PasswordResetPage error', e);
      setError(e);
    }
  };

  useEffect(() => {
    forceUpdate({});
  }, []);

  return (
    <div className={styles.container}>
      <div className={styles.logo_wrapper}>
        <img
          id="bup-logo"
          alt="BraveUp-Logo"
          src={Logo}
          style={{
            width: 300,
            height: 45,
          }}
        />
      </div>
      <div className={styles.content_container}>
        <div className={styles.description_text}>
          Ingresa la dirección de correo electrónico que usaste para
          registrarte. Te enviaremos un mensaje con un enlace para restablecer
          tu contraseña.
        </div>
        <Card className={styles.form_card} bodyStyle={{ padding: 0 }}>
          <Row>
            {error && error?.message ? (
              <Col xs={24} className={styles.card_error_wrapper}>
                <span>{error?.message}</span>
              </Col>
            ) : null}
            <Col xs={24} className={styles.card_form_wrapper}>
              <Form layout="vertical" form={form} onFinish={onSubmit}>
                <Form.Item
                  label="Correo Electrónico"
                  name="email"
                  rules={[
                    {
                      required: true,
                      message: 'Email requerido.',
                    },
                    {
                      required: true,
                      type: 'email',
                      message: 'El email no es valido.',
                    },
                  ]}
                >
                  <Input size="large" placeholder="micorreo@braveup.com" />
                </Form.Item>
                <Form.Item shouldUpdate>
                  {() => (
                    <Button
                      type="primary"
                      block
                      shape="round"
                      size="large"
                      htmlType="submit"
                      disabled={
                        form
                          .getFieldsError()
                          .filter(({ errors }) => errors.length).length
                      }
                    >
                      Enviar
                    </Button>
                  )}
                </Form.Item>
              </Form>
            </Col>
          </Row>
        </Card>
      </div>
    </div>
  );
};

export default PasswordResetSpanishPage;
